import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ProduitsWizard from './produitsWizard';

function ProduitModal({ modalShow, setModalShow }) {
  return (
    <>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <ProduitsWizard progressBar variant="pills" validation={true} />
        </Modal.Body>
      </Modal>
    </>
  );
}

ProduitModal.propTypes = {
  modalShow: PropTypes.bool.isRequired,
  setModalShow: PropTypes.func.isRequired
};

export default ProduitModal;
